export default "__VITE_ASSET__BUD7fNoK__"